const SubscriptionForm = () => {
    return (
        <iframe frameborder="0" id="iframewin" width="100%" height="100%" src="https://orex-zgph.maillist-manage.in/ua/Optin?od=1a1e3dbc5006a&zx=1dfa8f2929&tD=137083e537117a49&sD=137083e538090171"></iframe>
    )
}

export default SubscriptionForm;